import { useEffect } from "react";

import { useLazyQuery } from "@apollo/client";

import { GetSKUsQuery, GetSKUsQueryVariables } from "../../../../../API";
import { GET_SKUS } from "../../../../../common/operations/queries";
import { errorNotification } from "../../../../../common/variables/notification";
import client from "../../../../../configs/apolloClient";
import { DEFAULT_LIMIT_COUNT } from "../../../../../common/variables/common";

interface IUseGetLazyPaginatedSKUs {
  data?: GetSKUsQuery;
  loading: boolean;
}

export const useGetLazyPaginatedSKUs = (): IUseGetLazyPaginatedSKUs => {
  useEffect((): void => {
    fetchSKUs(DEFAULT_LIMIT_COUNT);
  }, []);

  const [getSKUs, { data, loading }] = useLazyQuery<
    GetSKUsQuery,
    GetSKUsQueryVariables
  >(GET_SKUS, {
    fetchPolicy: "network-only",
  });

  const handleRequestError = async (): Promise<void> => {
    await client.cache.reset();

    errorNotification();
  };

  const fetchSKUs = (limit: number, nextToken?: string): void => {
    getSKUs({
      variables: {
        limit,
        nextToken,
      },
    })
      .then(async (response): Promise<void> => {
        if (response.data?.getSKUs.nextToken) {
          fetchSKUs(DEFAULT_LIMIT_COUNT, response.data?.getSKUs.nextToken);
        }

        if (response.error) {
          await handleRequestError();
        }
      })
      .catch(async (): Promise<void> => {
        await handleRequestError();
      });
  };

  return { data, loading };
};
